import type { FC } from 'react';
import BlogSidebar from './BLogSidebar';
import BlogContent from './BlogContent';
import BlogHeader from './BlogHeader';

interface BlogDetailProps {
  title?: string;
  date?: string;
  excerpt?: string;
  description?: string[];
  image?: string;
}

const BlogDetail: FC<BlogDetailProps> = ({ title, date, excerpt, description, image }) => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <BlogHeader title={title} date={date} />
            <BlogContent excerpt={excerpt} image={image} title={title} description={description} />
            {/* <BlogSocialShare /> */}
          </div>
          <div className="lg:col-span-1">
            <BlogSidebar />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetail;